import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch, useSelector } from "react-redux";
import OrderMessagePanel from "pages/Order/components/OrderMessagePanel";
import { fetchOneOrder } from "redux/actions/order";

interface Props {
  open: boolean;
  onClose: () => void;
  orderId: number | null;
  driverTarget: "outward" | "return";
}

/**
 * #477: 配車画面 (DriverSchedule) でアイテムクリック時に開く driver 送信モーダル (送信のみ、 アサインなし)。
 * 既存 OrderMessagePanel を Dialog でラップし、 audience=driver タブ + driverTarget を自動選択。
 * 送信完了で order を refetch して配車画面の赤色判定を即時反映。
 */
const DriverSendDialog: React.FC<Props> = ({
  open,
  onClose,
  orderId,
  driverTarget,
}) => {
  const dispatch = useDispatch();
  const companyId = useSelector(
    (state: { account: { staff: { companyId: number } } }) =>
      state.account.staff.companyId
  );
  const targetLabel = driverTarget === "outward" ? "送り" : "迎え";
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6" style={{ display: "inline-block" }}>
          ドライバー送信 ({targetLabel})
        </Typography>
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <OrderMessagePanel
          orderId={orderId}
          initialTab="driver"
          initialDriverTarget={driverTarget}
          compactRows={5}
          onSent={() => {
            // 送信成功で 該当 order だけ refetch → 配車画面の sentTo*DriverAt が反映され赤色表示
            if (orderId) dispatch(fetchOneOrder(companyId, orderId));
            onClose();
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DriverSendDialog;
